import styled from "styled-components";
import { useInit, useWatcher } from "../system";
import Action from "./Action";
import General from "./General";
import Fields from "./fields";

const Wrapper = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    flex: 1;
    row-gap: calc(${(props) => props.theme.sizes.edge} * 2);
  }
  ${(props) => props.theme.medias.maxXL} {
    width: 100%;
  }
  ${(props) => props.theme.medias.maxMD} {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
    padding-inline: 0;
  }
`;

function Form() {
  useInit();
  useWatcher();

  return (
    <Wrapper>
      <General />
      <Fields.Streams />
      <Action />
    </Wrapper>
  );
}

export default Form;
